@import '../../../globals/main.scss';

pn-share-item {
  .pn-share-item__container {
    padding: 0.3rem 0.6rem;
    border: 1px solid $gray200;
    border-radius: 0.8rem;

    background-color: $white;
    transition: background-color ease-in-out 0.3s;
    width: fit-content;
  }

  a {
    text-decoration: none;
    color: $blue700;
    transition: color 0.3s;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    font-size: 1.6rem;
    font-weight: 400;
  }

  [slot='icon'] {
    svg {
      height: 1.6rem;
      width: 1.6rem;
      path {
        fill: $blue700;
        transition: fill 0.3s;
      }
    }
  }

  &:hover {
    cursor: pointer;

    .pn-share-item__container {
      background-color: $blue900;
    }

    a {
      color: $white;
      text-decoration: none;
    }

    [slot='icon'] {
      svg {
        fill: $blue900;
        path {
          fill: $white;
        }
      }
    }
  }
}
